module.exports = __webpack_public_path__ + "static/media/tutorial.8107d093.jpg";